import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, Stack } from '@mui/material';

import { DYNAMIC_PARAMS_FIELD } from './utils';
import { BlockValueTemplateInnerField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

interface AdditionalRowProps {
  index: number;
  onRemove: () => void;
}

export function AdditionalRow(props: AdditionalRowProps) {
  const { index, onRemove } = props;
  const keyFieldName = `${DYNAMIC_PARAMS_FIELD}.${index}.key`;
  const valueFieldName = `${DYNAMIC_PARAMS_FIELD}.${index}.value`;
  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Box flex={3}>
        <BlockValueTemplateInnerField
          label={`Key for row ${index + 1}`}
          fieldName={keyFieldName}
          fieldId={keyFieldName}
          placeholder="Key"
        />
      </Box>
      <Box flex={5}>
        <BlockValueTemplateInnerField
          label={`Value for row ${index + 1}`}
          fieldName={valueFieldName}
          fieldId={valueFieldName}
          placeholder="Value or {{UpstreamBlock.data.field}}"
        />
      </Box>
      <IconButton
        onClick={() => onRemove()}
        aria-label={`Delete variable row ${index + 1}`}
        size="small"
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}
